/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useEffect} from "react";
import {Package} from "types/entities/Package";
import {RouteComponentProps, withRouter} from "react-router-dom";
import PackageDetailInfoTitle from "pages/Front/Booking/components/PackageDetail/PackageDetailInfoTitle";
import PackageDetailInfoDetails from "pages/Front/Booking/components/PackageDetail/PackageDetailInfoDetails";
import PackageDetailInfoValues from "pages/Front/Booking/components/PackageDetail/PackageDetailInfoValues";
import SelectPackageButton from "pages/Front/Booking/components/Packages/SelectPackageButton";
import {isGiftCard} from "utils/packageUtils";
import {CURRENCY, SHOW_TYPICAL_TIMEPLAN} from "helpers/config";
import clsx from "clsx";
import {DataLayerItem} from "types/entities/specific/DataLayerItem";
import {translate} from "utils/utility";
import {GAEventName} from "types/entities/specific/GAEventName";
import {useTypedSelector} from "helpers/reducers";
import {useReactGoogleAnalytics} from "utils/useReactGoogleAnalytics";

interface Params {
    package_id: string;
}

interface PackageDetailProps extends RouteComponentProps<Params> {
    packageDetail: Package;
    //setSelectedPackage: (package_: Package) => void;
}

const PackageDetail = (props: PackageDetailProps) => {
    const bookingFilter = useTypedSelector(state => state.bookingState.bookingProcess.filter);
    const {sendGenericEvent} = useReactGoogleAnalytics();
    const sendGAData = () => {
        const count = bookingFilter.adults + bookingFilter.children;

        if (!props.packageDetail) {
            return;
        }
        const value = props.packageDetail.price * count;
        const item: DataLayerItem = {
            item_id: props.packageDetail.package_id,
            item_name: translate(props.packageDetail.name),
            quantity: count,
            item_variant: "",
            price: props.packageDetail.price,
            currency: CURRENCY,
        };

        sendGenericEvent(GAEventName.ViewItem, value, [item]);
    };

    useEffect(() => {
        sendGAData();
    }, []);

    return (
        <div key={props.packageDetail.id} className="PackageDetail flex flex-col">
            <div className={"PackageDetailInfo bg-white rounded-md shadow-md overflow-hidden flex flex-col text-base"}>
                <PackageDetailInfoTitle packageDetail={props.packageDetail} />
                <div className={clsx(SHOW_TYPICAL_TIMEPLAN ? "" : "justify-end", "PackageDetailPricing flex flex-col-reverse sm:flex-row px-4 sm:px-8 py-4")}>
                    {SHOW_TYPICAL_TIMEPLAN && (
                        <div className={"PackageDetailLeft flex flex-col flex-1"}>
                            {!isGiftCard(props.packageDetail) && <PackageDetailInfoDetails packageDetail={props.packageDetail} />}
                        </div>
                    )}

                    <div className={"PackageDetailInfoAction PackageDetailRight flex flex-col w-full sm:w-72"}>
                        <div className={"h-16 rounded-md overflow-hidden w-full flex flex-col"}>
                            <SelectPackageButton Package={props.packageDetail} />
                        </div>
                        <PackageDetailInfoValues packageDetail={props.packageDetail} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(PackageDetail);
